import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getCookieConsentChoice, setCookieConsentChoice, } from './cookie-consent-storage.js';
const CookieConsentContext = createContext(null);
export function CookieConsentProvider({ children }) {
    const [choice, setChoice] = useState(() => getCookieConsentChoice());
    const [preferencesOpen, setPreferencesOpen] = useState(false);
    const acceptCookies = useCallback(() => {
        setCookieConsentChoice('accepted');
        setChoice('accepted');
        setPreferencesOpen(false);
    }, []);
    const rejectCookies = useCallback(() => {
        setCookieConsentChoice('rejected');
        setChoice('rejected');
        setPreferencesOpen(false);
    }, []);
    const openCookiePreferences = useCallback(() => {
        setPreferencesOpen(true);
    }, []);
    const closeCookiePreferences = useCallback(() => {
        // Only allow closing without a choice once a prior decision exists.
        // First-visit (choice === null) must pick accept or reject.
        if (choice !== null) {
            setPreferencesOpen(false);
        }
    }, [choice]);
    const value = useMemo(() => ({
        choice,
        hasAnalyticsConsent: choice === 'accepted',
        preferencesOpen,
        acceptCookies,
        rejectCookies,
        openCookiePreferences,
        closeCookiePreferences,
    }), [
        acceptCookies,
        choice,
        closeCookiePreferences,
        openCookiePreferences,
        preferencesOpen,
        rejectCookies,
    ]);
    return _jsx(CookieConsentContext.Provider, { value: value, children: children });
}
export function useCookieConsent() {
    const context = useContext(CookieConsentContext);
    if (!context) {
        throw new Error('useCookieConsent must be used within CookieConsentProvider');
    }
    return context;
}
//# sourceMappingURL=CookieConsentProvider.js.map